<template>
  <v-col cols="5">
    <v-card
        @click.stop="dialog=true"
        class="actions-card"
    >
      <v-card-actions class="text-center actions-btn">
        <v-btn text class="actions-btn-text"><v-img src="../../../../../assets/svg/assign.svg"></v-img> Assign Cohort</v-btn>
      </v-card-actions>
    </v-card>



    <v-dialog
        v-model="dialog"
        width="480"
    >
      <v-card>
        <Loader :loading="loading" :message="message"/>
        <v-toolbar class="box"  @click.stop="dialog = false">
          <v-icon>mdi-close</v-icon>
          <v-toolbar-title>Close</v-toolbar-title>
        </v-toolbar>
        <div class="comment-content">
          <v-card-title class="comment-heading">Assign Cohort</v-card-title>
          <br/>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form v-if="!submitted" @submit.prevent="handleSubmit(assignToCohort)">
              <ValidationProvider name="Cohort" rules="required" v-slot="{errors}">
                <span class="err">{{ errors[0] }}</span>
                  <div class="row">
                    <v-select
                        :items="cohortData"
                        v-model="cohortId"
                        item-text="cohortName"
                        item-value="id"
                        label="Cohort Assigned To"
                        outlined
                    ></v-select>

        <!--            <v-col>-->
        <!--              <label class="payment-label">Payment Mode</label>-->
        <!--              <p class="payment-details">Bank Transfer</p>-->

        <!--            </v-col>-->
                  </div>
              </ValidationProvider>


          <div class="row">
            <v-textarea
                outlined
                name="input-7-4"
                row-height="15"
                label="Reason For Reassigning"
                v-model="reasonForDeferringAdmission"
                auto-grow
                />

          </div>
          <div >
            <v-card-actions>
              <v-btn
                  color="red"
                  class="submit"
                  depressed
                  x-large
                  type="submit"
                  width="100%"
                  block
              >
                Submit
              </v-btn>

            </v-card-actions>
          </div>
            </form>
          </ValidationObserver>
        </div>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import Loader from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/Loader";
import axios from "axios";
import {assignCohort, getAllCohort} from "@/services/ApiServices";
import {mapGetters} from "vuex";

export default {
name: "AssignCohort",
  components:{
  Loader
  },
  data(){
    return {

      dialog: false,
      cohortData:[],
      cohortId: "",
      reasonForDeferringAdmission: "",
      message: "Loading",
      loading: false,
      submitted: false

    }

  },


  methods:{
    getAllAvailableCohort(){
      const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
      axios.get(getAllCohort,{headers:elderHeader})
          .then(res=>{
            console.log(res.data)
            this.cohortData=res.data
          })
          .catch(err=>{
            console.log(err)
          })

      return this.cohortData;

    },
    assignToCohort(){
      this.loading=true;
      const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
      axios.patch(assignCohort,{
        applicantEmail: this.applicantEmail,
        cohortId: this.cohortId,
        reasonForDeferringAdmission: this.reasonForDeferringAdmission
      },{headers:elderHeader})
      .then(res=>{
        console.log(res.data)
        this.dialog=false
        alert(res.data.message)
      })
      .catch(err=>{
        console.log(err.response)
        this.loading=false;
        alert(err.response.data.message)
      })

    }

  },
  mounted() {
  this.getAllAvailableCohort();
  },
  computed: {

    ...mapGetters(['applicantEmail'])
  },


}
</script>

<style scoped>
.comment-heading{
  font-weight: 500!important;
  font-size: 32px !important;
  line-height: 33px!important;
  letter-spacing: -0.02em;
  color: #2B1C1C !important;
  margin-left:-17px;
}

.box{
  box-shadow: none!important;
  cursor: pointer;
}
.comment-content{
  margin-left: 52px;
  margin-right: 52px;
  font-family: IBM Plex Sans !important;
  font-style: normal!important;
  font-weight: normal;

}
.payment-label{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;

  color: #2B1C1C;

}
.submit{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 25px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;

  color: #FFFFFF;


}

.invite{
  font-family: IBM Plex Sans;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  display: flex;
  align-items: center !important;
  letter-spacing: 0.02em;
  color: #FF7E1D;
}
.err {
  color: red !important;
}
.invite-box{
  background: #FFDDD9;
  border-radius: 8px;
  padding: 3px;
}
.actions-btn{
  padding-top: 30px;
  margin-left: 45px;
}
.actions-btn-text{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  color: #2B1C1C;
  text-transform: capitalize!important;
}
.actions-card{
  border-radius: 8px;
  background: #FFF2C7;
  height: 95px;
}
</style>